import { InjectionToken } from '@angular/core';

export const OCL_EVENT_MODAL_TOKEN = new InjectionToken<any>('OclEventModalComponent');
